<template>
  <div>
    <b-card style="margin:20px">
      <div>
        <b-row>
          <b-col cols="2" style="width:300px">
            <Sidebar></Sidebar>
          </b-col>
          <div class="mr-1" style="border:solid;width:1px"></div>
          <b-col cols="1"></b-col>
          <b-col cols="6">
            <b-row>
              <h2 class="text-cente mx-3">Administor Registration</h2>
            
            </b-row>
            <div>
              <div>
                <b-form @submit.stop.prevent="onSubmit">
                  <div>
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="3"
                      label="User Role"
                      
                    >
                      
                      <b-form-select
                        style="background-image: none;"
                        :state="$v.admin.userRole.$dirty?($v.admin.userRole.required || !$v.admin.userRole.$dirty):null"
                        v-model="$v.admin.userRole.$model"
                        :options="options"
                      >
                        <template v-slot:first>
                          <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                        </template>
                      </b-form-select>
                    
                      <!-- <b-form-invalid-feedback
                        :state="($v.admin.userRole.required || !$v.admin.userRole.$dirty)"
                      >Valid Name is required.</b-form-invalid-feedback>-->
                    </b-form-group>
                  </div>
                  <div>
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="3"
                      label="Name"
                    >
                      <b-form-input
                        autocomplete="true"
                        :state="$v.admin.name.$dirty?($v.admin.name.required || !$v.admin.name.$dirty):null"
                        v-model.trim="$v.admin.name.$model"
                      ></b-form-input>
                      <!-- <b-form-invalid-feedback
                        :state="($v.admin.name.required || !$v.admin.name.$dirty)"
                      >Valid Name is required.</b-form-invalid-feedback>-->
                    </b-form-group>
                  </div>
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols-sm="4"
                    label-cols-lg="3"
                    label="Email"
                  >
                    <b-form-input
                      autocomplete="true"
                      :state="$v.admin.email.$dirty?($v.admin.email.required && $v.admin.email.email):null"
                      v-model.trim="$v.admin.email.$model"
                    ></b-form-input>
                    <!-- <b-form-invalid-feedback
                      :state="!($v.admin.email.required && !$v.admin.email.$dirty)"
                    >
                      Valid Email is required 
                    </b-form-invalid-feedback>-->
                  </b-form-group>
                  <div>
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="3"
                      label="Username"
                    >
                      <b-form-input
                        autocomplete="true"
                        :state="$v.admin.username.$dirty?($v.admin.username.required || !$v.admin.username.$dirty):null"
                        v-model.trim="$v.admin.username.$model"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div>
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="3"
                      label="Password"
                    >
                      <b-form-input
                        autocomplete="true"
                        :state="$v.admin.password.$dirty?($v.admin.password.required || !$v.admin.password.$dirty):null"
                        v-model.trim="$v.admin.password.$model"
                        type="password"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div>
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="3"
                      label="Age"
                    >
                      <b-form-input
                        autocomplete="true"
                        :state="$v.admin.age.$dirty?($v.admin.age.required || !$v.admin.age.$dirty):null"
                        v-model.trim="$v.admin.age.$model"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div>
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="3"
                      label="Gender"
                    >
                      <b-form-select
                        style="background-image: none;"
                        :state="$v.admin.gender.$dirty?($v.admin.gender.required || !$v.admin.gender.$dirty):null"
                        v-model.trim="$v.admin.gender.$model"
                        :options="options"
                      >
                        <template v-slot:first>
                          <b-form-select-option
                            :value="null"
                            disabled
                          >-- Please select your gender --</b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </div>
                  <div>
                    <b-form-group
                      id="fieldset-horizontal"
                      label-cols-sm="4"
                      label-cols-lg="3"
                      label="Mobile Number"
                    >
                      <b-form-input
                        autocomplete="true"
                        :state="$v.admin.mobile.$dirty?($v.admin.mobile.required || !$v.admin.mobile.$dirty):null"
                        v-model.trim="$v.admin.mobile.$model"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div>
                    <b-button variant="primary" @click="submitData()">Submit</b-button>
                  </div>
                </b-form>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import Sidebar from "../AdminSlidebar";
import { required, email } from "vuelidate/lib/validators";
export default {
  name: "AdminAddUser",
  components: {
    Sidebar
  },
  validations: {
    admin: {
      name: {
        required
      },
      userRole: {
        required
      },
      email: {
        required,
        email
      },
      username: {
        required
      },
      password: {
        required
      },
      age: {
        required
      },
      gender: {
        required
      },
      mobile: {
        required
      }
    }
  },
  methods: {
    submitData() {
      this.$v.admin.$touch();
      if (this.$v.admin.$anyError) {
        return;
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    }
  },
  data() {
    return {
      options: ["Apple", "Banana", "Grape", "Kiwi", "Orange"],
      admin: {
        userRole: null,
        name: "",
        email: "",
        username: "",
        password: "",
        age: "",
        gender: null,
        mobile: ""
      }
    };
  }
};
</script>

<style>
/* .form-control.is-invalid {
    background-image: none;
    padding-right: inherit;
} */
</style>